/*
    This element gives ability to select quote attributes
 */

import React, {useEffect, useState} from 'react'
import { useSelector, useDispatch } from "react-redux";
import URLService from "./services/URLService";
import {setLanguage, setProjectName, setProjectType, setQuantity} from "../store/details/projectDetailsSlice";
import CurrencySelector from "./CurrencySelector";
import LanguageSelector from "./LanguageSelector";
import QuoteDetails from "./QuoteDetails";

const ProjectDetails = (props) => {
    const dispatch = useDispatch();
    const quantity = useSelector(state => state.projectDetailsReducer.quantity);
    const projectName = useSelector(state => state.projectDetailsReducer.projectName);
    const projectType = useSelector(state => state.projectDetailsReducer.projectType);
    const quoteId = useSelector(state => state.projectDetailsReducer.quoteId);
    const currentUrl = useSelector(state => state.configuratorStateReducer.currentUrl);
    const lineNumber = useSelector(state => state.projectDetailsReducer.lineNumber);
    const notices = useSelector(state => state.notices);
    const [newQuote, setNewQuote] = useState(true);

    useEffect(() => {
        setNewQuote(URLService.is_quote_url())
    }, [currentUrl]);

    const handleNameChange = (event) => {
        dispatch(setProjectName(event.target.value))
    }

    const handleTypeChange = (event) => {
        dispatch(setProjectType(event.target.value))
    }

    const handleQuantityChange = (event) => {
        dispatch(setQuantity(event.target.value))
    }

    // this is needed because inside of the input box enter submits the whole form
    const handleKeypress = (event) => {
        if(event.key === 'Enter'){
            event.preventDefault();
        }

    }

    const shouldShowError = (type) => {
        const matchingNotice = notices.find(notice => notice.notice_type == type );
        if(matchingNotice){
            return true;
        }
        return false;
    }

    const projectNameField = () => {
        if(newQuote){
            return  ([
                <div className="field-wrapper" key={'name-wrapper'}>
                    <label className="fixed-width">Project Name:</label>
                    <input value={projectName}
                           type="text" maxLength="40"
                           required
                           onChange={(e) => handleNameChange(e)}
                           onKeyPress={(e) => handleKeypress(e)}
                           id="projectNameInput"
                           className={(shouldShowError('project_name') ? " warning":'')}
                    />


                </div>,
                getWarning('project_name')]
            );
        // this means it is edit
        } else {
            return (
                <div className="field-wrapper">
                    <label className="fixed-width">Project Name:</label>
                    <div>{projectName}</div>
                </div>
            );
        }

    }

    const getTitle = () => {
        if(newQuote) {
            return <>New Quote <br/>& Item</>
        } else {
            return <>Configure Item</>
        }
    }

    const renderSubProjectFields = () =>  {
        // this means it is edit or new quote item
        if(newQuote) {
            return(
                <div className="small-12 columns">
                    <span className="first-line">First Item</span>
                </div>
            )
        } else {
            return ([
                    <div className="small-6 columns padding-between">
                        <div className="field-wrapper">
                            <label className="fixed-width">Quote #:</label>
                            <div>{quoteId}</div>
                        </div>
                    </div>,
                    <div className="small-6 columns padding-between">
                        <div className="field-wrapper align-right">
                            <label>Line #:</label>
                            <div className="line-number-padding">{lineNumber}</div>
                        </div>
                    </div>
                ]
            );
        }
    }

    const getWarning = (type) => {
        let warning = null;
        if(shouldShowError(type)) {
            const notice = notices.find(warn => warn.notice_type == type);
            warning = <div className='warning-text'>{notice.message}</div>
        }
        return warning;
    }


    const createdAtOrCurrency = () => {

    }

    return (
        <div className="quote-details quote-details-wrapper" id="quote-details">

            <div className="row setup-steps project-step">
                <div className="small-12 columns">
                <div className="row">
                    <div className="small-3 columns">
                                <h2>{getTitle()}</h2>
                            </div>
                            <div className="small-6 columns">
                                <div className="row">
                                    <div className="small-12 medium-12 columns">
                                        {projectNameField()}
                                    </div>
                                    {renderSubProjectFields()}
                                    <div className="small-12 medium-5 columns">
                                        <div className="field-wrapper">
                                            <label className="fixed-width">Item Type:</label>
                                            <input value={projectType} maxLength="10" size="10" type="text"
                                                   onChange={(e) => handleTypeChange(e)}
                                                   onKeyPress={(e) => handleKeypress(e)}
                                                   required className={(shouldShowError('type') ? 'warning':'')}

                                            ></input>
                                        </div>
                                        { getWarning('type') }

                                    </div>
                                    <div className="small-12 medium-5 offset-2 columns">
                                        <div className="field-wrapper align-right">
                                            <label>Quantity:</label>
                                            <input value={quantity} min="1" max="99999" type="number"
                                                   required
                                                   onChange={(e) => handleQuantityChange(e)}
                                                   onKeyPress={(e) => handleKeypress(e)}
                                                   className={(shouldShowError('quantity') ? 'warning':'')}></input>
                                        </div>
                                        { getWarning('quantity') }

                                    </div>

                                </div>
                            </div>
                            <div className="small-12 medium-3 columns">
                                {<QuoteDetails newQuote={newQuote} languages={props.languages}/>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default  ProjectDetails;